/* src/app/subcontractor/pages/subcontractor-new/subcontractor-new.component.scss */
/*# sourceMappingURL=subcontractor-new.component.css.map */
